"use client";

import { useState } from "react";
import Image, { type ImageProps } from "next/image";
import { cn } from "@/lib/utils";
import fallbackImage from "@/images/blog-fallback.png";

// Define our custom props type
type PostImageProps = Omit<ImageProps, "src" | "alt"> & {
  src: string | null | undefined;
  alt?: string;
};

export function PostImage({
  src,
  alt = "Blog image",
  ...props
}: PostImageProps) {
  const [hasError, setHasError] = useState(false);

  // Determine the image source based on error state and provided src
  const imageSrc = hasError || !src ? fallbackImage.src : src;

  return (
    <Image
      {...props}
      className={cn(
        "object-cover",
        hasError && "object-contain",
        props.className
      )}
      src={imageSrc}
      alt={alt}
      onError={() => setHasError(true)}
    />
  );
}
